import { Container as MUIContainer } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(MUIContainer)`
  padding: 0;
`;
